import React, {useState} from 'react';
import {Col, FormFeedback, Input, Row} from "reactstrap";
import Select from "react-select";
import ModalAddNewCustomer from "../../Parties/Modal/ModalAddNewCustomer";
import {useSelector} from "react-redux";

const BillingInformation = ({ formik, proceedToNext, setBillingInfo }) => {
    const { customer_data } = useSelector((state) => state?.customer);
    const [addNewCustomerModal, setAddNewCustomerModal] = useState(false);
    const { tenant_info } = useSelector((state) => state?.settings);

    const customerNameLists = customer_data?.content?.length > 0
        ? [...(customer_data?.content?.map(customer => ({
            key: customer.id,
            value: customer.id.toString(),
            label: customer.name,
            version: customer.version,
            address: customer?.address,
            city: customer?.city,
            pinCode: customer?.pinCode,
            country: customer?.country,
            state: customer?.state,
            contactName: customer?.contactName,
            contactEmail: customer?.contactEmail,
            contactNo: customer?.contactNo,
        })) || []),
            {
                value: "self",
                label: "Self",
                version: "0"
            },
            {
                value: "addnew",
                label: "Add New Customer",
                version: "0"
            }] : [{ value: "self", label: "Self", version: "0" }, { value: "addnew", label: "Add New Customer", version: "0" }];

    const onCloseClick = () => {
        setAddNewCustomerModal(false);
    }

    return(
        <>
            <div className='charges_wrap'>
                <Row>
                    <Col md={6}>
                        <div className="mb-3">
                            <label className="form-label">Customer Name<span
                                className='required_star'>*</span></label>
                            <div className='field_wrap'>
                                <Select
                                    id='billingCustomerName'
                                    name='billingCustomerName'
                                    value={formik?.values?.billingCustomerName}
                                    onChange={async (e) => {
                                        if (e.value === 'addnew') {
                                            setAddNewCustomerModal(true);
                                            formik.setFieldValue('customerAddress', '');
                                            formik.setFieldValue('contactName', '');
                                            formik.setFieldValue('contactEmail', '');
                                            formik.setFieldValue('contactNumber', '');
                                            formik.setFieldValue('customerName', '');
                                        } else if (e.value === 'self') {
                                            formik.setFieldValue('billingCustomerAddress', tenant_info?.address || '');
                                            formik.setFieldValue('billingContactName', tenant_info?.firstName + tenant_info?.lastName || '');
                                            formik.setFieldValue('billingContactEmail', tenant_info?.email || '');
                                            formik.setFieldValue('billingContactNumber', tenant_info?.contactNumber || '');
                                            await formik.setFieldValue('billingCustomerName', e, true);
                                            formik.setFieldTouched('billingCustomerName', true, true);
                                            setBillingInfo(tenant_info);
                                        } else {
                                            console.log('e', e);
                                            const customerAddress =
                                                (e?.address || '') + ' ' +
                                                (e?.city?.cityName || '') + ' ' +
                                                (e?.state?.stateName || '') + ' ' +
                                                (e?.pinCode?.pin || '') + ' ' +
                                                (e?.country?.countryName || '');
                                            formik.setFieldValue('billingCustomerAddress', customerAddress);
                                            formik.setFieldValue('billingContactName', e?.contactName || '');
                                            formik.setFieldValue('billingContactEmail', e?.contactEmail || '');
                                            formik.setFieldValue('billingContactNumber', e?.contactNo || '');
                                            //formik.setFieldValue('billingCustomerName', e);
                                            await formik.setFieldValue('billingCustomerName', e, true); // true triggers validation after set
                                            formik.setFieldTouched('billingCustomerName', true, true); // true triggers validation after touch
                                            setBillingInfo(e);
                                        }
                                    }}
                                    placeholder="Select Customer"
                                    options={customerNameLists}
                                    classNamePrefix="form-select"
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.billingCustomerName && !!formik.errors.billingCustomerName}
                                    styles={{
                                        control: (baseStyles) => {
                                            let borderColor = baseStyles.borderColor;
                                            borderColor = formik.errors.billingCustomerName ? 'red' : 'grey';
                                            return {
                                                ...baseStyles,
                                                borderColor,
                                            };
                                        },
                                    }}
                                />
                                <FormFeedback>{formik.errors.billingCustomerName}</FormFeedback>
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Customer Address</label>
                            <Input
                                type="textarea"
                                id="billingCustomerAddress"
                                name="billingCustomerAddress"
                                rows="4"
                                placeholder="Enter Customer Address..."
                                value={formik?.values?.billingCustomerAddress}
                                onChange={formik?.handleChange}
                                onBlur={formik?.handleBlur}
                                invalid={formik?.touched?.billingCustomerAddress && !!formik?.errors?.billingCustomerAddress}
                            />
                            <FormFeedback>{formik?.errors?.billingCustomerAddress}</FormFeedback>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="mb-3">
                            <label className="form-label">Contact Name</label>
                            <Input
                                id="billingContactName"
                                name="billingContactName"
                                placeholder="Enter Contact Name..."
                                value={formik?.values?.billingContactName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                invalid={formik?.touched?.billingContactName && !!formik?.errors?.billingContactName}
                            />
                            <FormFeedback>{formik?.errors?.billingContactName}</FormFeedback>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Contact Email</label>
                            <Input
                                type="email"
                                id="billingContactEmail"
                                name="billingContactEmail"
                                placeholder="Enter Contact Email..."
                                value={formik?.values?.billingContactEmail}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                invalid={formik?.touched?.billingContactEmail && !!formik?.errors?.billingContactEmail}
                            />
                            <FormFeedback>{formik?.errors?.billingContactEmail}</FormFeedback>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Contact Number</label>
                            <Input
                                id="billingContactNumber"
                                name="billingContactNumber"
                                type="number"
                                pattern="\d*"
                                minLength={10}
                                maxLength={10}
                                placeholder="Enter Contact Number..."
                                value={formik?.values?.billingContactNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                invalid={formik?.touched?.billingContactNumber && !!formik?.errors?.billingContactNumber}
                            />
                            <FormFeedback>{formik?.errors?.billingContactNumber}</FormFeedback>

                            {/*<Row>*/}
                            {/*    <Col xs="4">*/}
                            {/*        <Input*/}
                            {/*            id="contactNumber1"*/}
                            {/*            name="contactNumber1"*/}
                            {/*            value={customerDetailsFormik.values.contactNumber1}*/}
                            {/*            onChange={customerDetailsFormik.handleChange}*/}
                            {/*            onBlur={customerDetailsFormik.handleBlur}*/}
                            {/*            invalid={customerDetailsFormik.touched.contactNumber1 && !!customerDetailsFormik.errors.contactNumber1}*/}
                            {/*        />*/}
                            {/*        <FormFeedback>{customerDetailsFormik.errors.contactNumber1}</FormFeedback>*/}
                            {/*    </Col>*/}
                            {/*    <Col xs="8">*/}
                            {/*        */}
                            {/*    </Col>*/}
                            {/*</Row>*/}
                        </div>
                    </Col>
                </Row>
                <div className="d-flex justify-content-end">
                    <button className="btn btn-primary" onClick={(e) => {
                        e.preventDefault();
                        proceedToNext("customerdetails");
                    }}>Continue</button>
                </div>
            </div>
            <ModalAddNewCustomer modal={addNewCustomerModal} onCloseClick={onCloseClick} />
        </>
    )
}

export default BillingInformation;
